import { Switch, makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useThemeMode } from '@src/contexts/ThemeMode';
import MoonIcon from '@src/resources/icons/MoonIcon';
import SunIcon from '@src/resources/icons/SunIcon';
import { FC } from 'react';
import { useIntl } from 'react-intl';

const ThemeModeToggle: FC = () => {
  const { mode, toggle } = useThemeMode();
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isDark = mode === 'dark';
  const primaryColor = theme.palette.primary.main;
  const classes = useStyles();
  const label = formatMessage({
    id: isDark ? 'Header.theme.light' : 'Header.theme.dark',
  });

  const thumbStyle: React.CSSProperties = {
    width: 18,
    height: 18,
    borderRadius: '50%',
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: primaryColor,
  };

  return (
    <Switch
      checked={isDark}
      onChange={toggle}
      size="small"
      color="primary"
      inputProps={{ 'aria-label': label }}
      icon={
        <span style={thumbStyle}>
          <SunIcon style={{ width: 10, height: 10 }} />
        </span>
      }
      checkedIcon={
        <span style={thumbStyle}>
          <MoonIcon style={{ width: 10, height: 10 }} />
        </span>
      }
      classes={{
        sizeSmall: classes.sizeSmall,
      }}
    />
  );
};

export default ThemeModeToggle;

const useStyles = makeStyles(() => ({
  sizeSmall: {
    '& .MuiSwitch-switchBase': {
      marginTop: 1,
      marginLeft: 2,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(14px)',
    },
  },
}));
